import { Styles } from "@chakra-ui/theme-tools"

const styles: Styles = {
  global: (props: any) => ({
    html: { 
      scrollBehavior: 'smooth',
      fontSize: props.theme.baseFontSize
    },
    body: {
      bg: 'chakra-body-bg',
      color: 'chakra-body-text',
      lineHeight: 'normal',
      transitionProperty: 'background-color',
      transitionDuration: 'normal',
    },
    h1: { mb: 4 },
    '*::placeholder': {
      color: 'chakra-placeholder-color',
    },
    '*, *::before, &::after': {
      borderColor: 'chakra-border-color',
      wordWrap: 'break-word'
    },
  })
}

export default styles;
